export const getCenterOfSchools = (schools) => {
    // Schools Coordinates
    const school1 = schools[0];
    const school2 = schools[1];
    const school3 = schools[2];

    const lat1 = school1.coordinates.lat;
    const lat2 = school2.coordinates.lat;
    const lat3 = school3.coordinates.lat;

    const lng1 = school1.coordinates.lng;
    const lng2 = school2.coordinates.lng;
    const lng3 = school3.coordinates.lng;

    // Latitudes
    const lat12 = lat1 - lat2;
    const lat13 = lat1 - lat3;
    const lat21 = lat2 - lat1;
    const lat31 = lat3 - lat1;

    // Longitudes
    const lng12 = lng1 - lng2;
    const lng13 = lng1 - lng3;
    const lng21 = lng2 - lng1;
    const lng31 = lng3 - lng1;

    const slat13 = Math.pow(lat1, 2) - Math.pow(lat3, 2);
    const slat21 = Math.pow(lat2, 2) - Math.pow(lat1, 2);

    const slng13 = Math.pow(lng1, 2) - Math.pow(lng3, 2);
    const slng21 = Math.pow(lng2, 2) - Math.pow(lng1, 2);

    const f =
        (slat13 * lat12 +
            slng13 * lat12 +
            slat21 * lat13 +
            slng21 * lat13) /
        (2 * (lng31 * lat12 - lng21 * lat13));
    const g =
        (slat13 * lng12 +
            slng13 * lng12 +
            slat21 * lng13 +
            slng21 * lng13) /
        (2 * (lat31 * lng12 - lat21 * lng13));

    const c =
        -Math.pow(lat1, 2) -
        Math.pow(lng1, 2) -
        2 * g * lat1 -
        2 * f * lng1;

    // Coordinates of Center
    const h = -g;
    const k = -f;

    const sqr_of_r = h * h + k * k - c;

    const r = Math.sqrt(sqr_of_r);

    let zoom;

    if (r * 100 * 0.5 < 3) {
        zoom = 12;
    } else if (r * 100 * 0.5 <= 8) {
        zoom = 11;
    } else {
        zoom = 10;
    }

    return { coordinates: { latitude: h, longitude: k }, zoom: zoom };
}

export const sortSchoolsByDistance = (schools, location) => {
    schools.forEach(school => {
        const coordinates = school.coordinates;
        const latDiff = Math.abs(coordinates.lat - location.lat);
        const lngDiff = Math.abs(coordinates.lng - location.lng);

        school.distanceOfLocation = latDiff + lngDiff;
    });

    schools.sort(
        (a, b) => a.distanceOfLocation - b.distanceOfLocation
    );

    return schools
}